import { enumXMLType } from "../constants";
import { XML_DrawBoxGroupHighlightPPT } from "./XML_DrawBoxGroupHighlightPPT";
import { XML_DrawBoxGroupHighlightPDF } from "./XML_DrawBoxGroupHighlightPDF";

export function XML_DrawBoxGroupHighlight(xOffset, yOffset, poly, fillStyle, drawElement, layer) {
  var docType = drawElement.GetDocType();

  if (docType == enumXMLType.PDF) {
    XML_DrawBoxGroupHighlightPDF(xOffset, yOffset, poly, fillStyle, drawElement, layer);
  } else {
    XML_DrawBoxGroupHighlightPPT(xOffset, yOffset, poly, fillStyle, drawElement, layer);
  }
}
